import { Icon } from "../../../../components/BaseComponents/Icon";

export const PhoneIcon = (props) => (
	<Icon fill="none" {...props}>
		<circle
			cx="12"
			cy="12"
			r="11"
			fill="white"
			stroke="#283033"
			strokeWidth="2"
		/>
		<g>
			<path
				d="M17.3141 13.8002L14.9614 12.7562C14.7287 12.6533 14.4685 12.63 14.2211 12.6899C13.9738 12.7498 13.7532 12.8897 13.5934 13.0877L12.8831 13.9765C11.7321 13.2443 10.7559 12.2683 10.0234 11.1175L10.9114 10.408C11.1101 10.2484 11.2506 10.0276 11.3108 9.77987C11.371 9.53218 11.3477 9.27153 11.2444 9.03849L10.1996 6.68574C10.0886 6.43584 9.89254 6.23347 9.64627 6.11466C9.4 5.99585 9.11955 5.96832 8.85488 6.03699L6.86588 6.55374C6.59147 6.62542 6.35289 6.79525 6.19531 7.03106C6.03773 7.26688 5.97211 7.55229 6.01088 7.83324C6.37921 10.3961 7.56784 12.7708 9.39878 14.6016C11.2297 16.4324 13.6044 17.6208 16.1674 17.989C16.2201 17.9964 16.2732 18.0002 16.3264 18.0002C16.5825 18.0001 16.8313 17.9151 17.0339 17.7584C17.2365 17.6018 17.3814 17.3825 17.4461 17.1347L17.9621 15.145C18.0318 14.8804 18.0048 14.5996 17.886 14.3532C17.7673 14.1067 17.5645 13.9106 17.3141 13.8002Z"
				fill="#283033"
			></path>
		</g>
		<defs>
			<clipPath>
				<rect
					width="12"
					height="12"
					fill="white"
					transform="translate(6 6)"
				></rect>
			</clipPath>
		</defs>
	</Icon>
);
